import { useMountEffect } from '@react-hookz/web';
import { uniqueId } from 'lodash-es';
import React, { useState } from 'react';
import { Box, Spinner } from '@apia/theme';
import { arrayOrArray } from '../../../../../utils/util';
import {
  TResponsiveTableRow,
  TResponsiveTableCellRenderer,
  TResponsiveTableCellRendererProps,
} from '../types';

export default function makeAsyncRenderer(
  additionalInfoGetter: (row: TResponsiveTableRow) => Promise<
    {
      label?: string;
      name: string;
      newline?: boolean;
    }[]
  >,
) {
  const InnerRender: TResponsiveTableCellRenderer = React.forwardRef<
    HTMLElement,
    TResponsiveTableCellRendererProps
  >(({ row }, ref) => {
    const [moreInfo, setMoreInfo] = useState<
      | {
          label?: string;
          name: string;
          newline?: boolean;
        }[]
      | null
    >(null);
    useMountEffect(async () => {
      const result = await additionalInfoGetter(row);
      setMoreInfo(result);
    });
    return (
      <>
        {moreInfo ? (
          arrayOrArray(moreInfo).map((dataCell) => {
            return (
              <Box
                key={`${dataCell.name}-${uniqueId()}`}
                ref={ref}
                className={`responsiveTable__additionalInfoItem ${
                  dataCell.newline ? 'separator' : ''
                }`}
              >
                {dataCell.newline ? (
                  <>
                    <Box sx={{ height: '20px' }} as="strong">
                      {dataCell.name}
                      {dataCell.name ? ':' : ''}
                    </Box>{' '}
                    {dataCell.label}
                  </>
                ) : (
                  <>
                    <Box as="strong">{dataCell.name}:</Box> {dataCell.label}
                  </>
                )}
              </Box>
            );
          })
        ) : (
          <Spinner size={15} />
        )}
      </>
    );
  });

  return InnerRender;
}
